<!-- eslint-disable max-len -->
<template>
  <div
    id="modal-not-propagated"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="modalNotPropagated"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <p class="w-100 text-start fs-5 fw-600 m-0">
            Ainda não encontramos o código propagado em seu DNS
          </p>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>

        <div class="modal-body">
          <div class="mb-5">
            <img src="@/assets/images/looking-warning.svg" alt="waiting-room" />
          </div>

          <div class="text-start">
            <p class="text-start">
              As vezes o processo de propagação pode demorar um pouco.
            </p>

            <p class="w-100 text-start fs-6 fw-600 m-0">Recomendações:</p>
            <div class="d-flex mt-2">
              <Icon
                name="circle-exclamation"
                color="warning"
                style="margin-right: 8px; margin-top: 2px"
              />
              <p>
                <span class="fw-600"
                  >Se você iniciou a validação há mais de 24 horas:</span
                >
                Recomendamos que refaça a validação, <br />verificando todos os
                dados.
              </p>
            </div>
            <div class="d-flex">
              <Icon
                name="circle-exclamation"
                color="warning"
                style="margin-right: 8px; margin-top: 2px"
              />
              <p>
                <span class="fw-600"
                  >Se você iniciou a validação há menos de 2 horas:</span
                >
                Pedimos que aguarde mais um pouco.
              </p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="w-100 d-flex justify-content-end">
            <button class="btn btn-primary" @click="hideModal">
              <span>Ok. Entendi</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { Modal } from 'bootstrap'
  import Icon from '@/components/Atoms/Icon.vue'

  export default defineComponent({
    components: {
      Icon,
    },
    data() {
      return {
        modal: null as null | Modal,
      }
    },
    mounted() {
      this.modal = new Modal(
        document.getElementById('modal-not-propagated') as HTMLElement,
        {},
      )
    },
    methods: {
      showModal() {
        this.modal?.show()
      },
      hideModal() {
        this.modal?.hide()
      },
    },
  })
</script>
